import type { CityConfig } from "@/pages/city-template/types";

export const winnemuccaConfig: CityConfig = {
  city: "Winnemucca",
  state: "Nevada",
  stateAbbr: "NV",
  slug: "winnemucca",
  route: "/winnemucca",
  title: "Emergency & Expedited Passport Services Winnemucca NV | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Winnemucca, NV — as fast as 24 hours. No Winnemucca passport agency. Fast Passport Center couriers to the San Francisco Passport Agency at 450 Golden Gate Ave. A+ BBB rated. Serving Humboldt County ranching communities, I-80 mining professionals, and northern Nevada travelers.",
  h1: "Emergency & Expedited Passport Services in Winnemucca, NV",
  heroSubtitle: "Winnemucca is the seat of Humboldt County, a rugged I-80 town in northern Nevada known for gold mining, Basque heritage, and wide-open high desert landscapes. Fast Passport Center's registered couriers deliver your documents to the San Francisco Passport Agency at 450 Golden Gate Ave so you get a new or renewed passport as fast as 24 hours — whether you're a Winnemucca mining professional heading to an international mining convention in Australia, a Humboldt County rancher traveling to a livestock exhibition in Canada, or a northern Nevada family planning a long-awaited trip overseas.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Winnemucca%20Nevada%20high%20desert%20landscape%20with%20Humboldt%20River%20winding%20through%20sagebrush%20valley%20surrounded%20by%20distant%20mountain%20ranges%20under%20vast%20blue%20sky%20at%20golden%20sunset%2C%20historic%20I-80%20cowtown%20with%20western%20storefronts%20along%20main%20street%2C%20northern%20Nevada%20ranching%20and%20mining%20country%20with%20dramatic%20cloud%20formations%20over%20desert%20basin&width=1800&height=700&seq=winnemucca-nv-hero-001&orientation=landscape",
  heroImageAlt: "Winnemucca Nevada high desert landscape with Humboldt River and distant mountains at golden sunset",
  geoPosition: "40.9730;-117.7357",
  geoPlacename: "Winnemucca, Nevada",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "San Francisco Passport Agency",
    address: "450 Golden Gate Ave, San Francisco, CA 94102",
    distance: "Approximately 390 miles from Winnemucca — about 6 hours via I-80 west",
  },
  nearbyCitiesZips: [
    { name: "Winnemucca", zips: "89445" },
    { name: "Battle Mountain", zips: "89820" },
    { name: "Lovelock", zips: "89419" },
    { name: "Elko", zips: "89801" },
    { name: "Spring Creek", zips: "89815" },
    { name: "Fernley", zips: "89408" },
    { name: "Fallon", zips: "89406" },
    { name: "McDermitt", zips: "89421" },
    { name: "Golconda", zips: "89414" },
    { name: "Valmy", zips: "89425" },
    { name: "Paradise Valley", zips: "89426" },
    { name: "Reno", zips: "89501, 89502" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to San Francisco Passport Agency — serving Winnemucca and Humboldt County" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Humboldt County & I-80 Corridor", desc: "Serving Winnemucca, Battle Mountain, Lovelock, and northern Nevada" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Winnemucca case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Reno NV", route: "/reno" },
    { name: "Expedited passport in Elko NV", route: "/elko" },
    { name: "Urgent passport in Winnemucca NV", route: "/winnemucca" },
    { name: "Nevada passport hub", route: "/nevada" },
    { name: "Fast passport in Battle Mountain NV", route: "/battle-mountain" },
    { name: "Expedited passport in Fallon NV", route: "/fallon" },
    { name: "Emergency passport in Carson City NV", route: "/carson-city" },
  ],
  fpcOfficeAddress: "299 S Main St, Salt Lake City, Utah 84111",
  fpcOfficeNote: "Fast Passport Center serves Winnemucca remotely via secure courier. Our registered couriers hand-deliver your documents to the San Francisco Passport Agency at 450 Golden Gate Ave — approximately 390 miles away. Winnemucca's location on I-80 with reliable interstate access to both Reno and San Francisco makes overnight courier routing dependable, and our dedicated agents ensure Humboldt County travelers never need to make the 12-hour round trip drive to San Francisco.",
  fpcOfficeDistance: "Serving all of Humboldt County and the I-80 corridor of northern Nevada",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Winnemucca, Battle Mountain, Lovelock, and the greater Humboldt County area. From I-80 mining professionals heading to international conferences to Basque-heritage families traveling to Europe, we help northern Nevadans get their passports fast.",
  nearbyCitiesIntro: "We serve Winnemucca and nearby communities including Battle Mountain, Lovelock, Elko, Fernley, Fallon, McDermitt, and the entire Humboldt County area.",
  howItWorksIntro: "Most Winnemucca travelers complete everything online and ship documents overnight. Fast Passport Center provides fast courier turnaround for Humboldt County residents — eliminating the 12-hour round trip to the San Francisco Passport Agency.",
  mistakesIntro: "Winnemucca travelers, including I-80 mining professionals, Humboldt County ranchers, and rural northern Nevada families, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Winnemucca and Humboldt County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Winnemucca? Here are the most common ones we hear from Humboldt County and northern Nevada travelers.",
  statePageRoute: "/states/nevada",
  statePageName: "Nevada",
  dmvWebsite: "https://dmv.nv.gov/",
  dmvLabel: "Nevada DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at 450 Golden Gate Ave",
        "Life-or-death emergencies only",
        "390 miles to San Francisco (6 hours via I-80)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for rural Nevada families traveling abroad",
        "Perfect for I-80 mining professionals",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from RNO",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Winnemucca is 390 miles from the San Francisco Passport Agency — our courier service saves Humboldt County travelers a 12-hour I-80 round trip.",
      bullets: ["Northern Nevada coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Northern NV",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Winnemucca adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Winnemucca and Humboldt County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Winnemucca and Humboldt County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Winnemucca, Battle Mountain, and Humboldt County residents with DS-64 form guidance.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via SF agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Humboldt County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Winnemucca and Humboldt County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Winnemucca NV", description: "Urgent passport processing for Winnemucca, NV travelers via San Francisco Passport Agency courier." },
    { name: "Passport Renewal Winnemucca NV", description: "Fast passport renewal for Winnemucca and Humboldt County, Nevada residents." },
    { name: "New Passport Winnemucca NV", description: "First-time passport application assistance for Winnemucca and northern Nevada area residents." },
    { name: "Lost Passport Winnemucca NV", description: "Passport replacement for lost or stolen passports for Winnemucca and northern Nevada residents." },
    { name: "Child Passport Winnemucca NV", description: "Minor passport services for Winnemucca and Humboldt County families." },
    { name: "Name Change Passport Winnemucca NV", description: "Passport name change service for Winnemucca, NV residents." },
  ],
  testimonials: [
    {
      name: "Dan R.",
      location: "Winnemucca — Mining Operations Manager",
      rating: 5,
      text: "Gold mining operations manager called to an international mining convention in Perth, Australia on 12 days notice. Realized my passport had expired 8 months ago. Fast Passport Center expedited the renewal through San Francisco in 3 business days. Made the convention and the keynote dinner. Incredible turnaround from the middle of nowhere Nevada.",
      service: "Emergency Business Passport",
    },
    {
      name: "Maria & Jose E.",
      location: "Winnemucca — Basque Heritage Family",
      rating: 5,
      text: "Winnemucca family planning a long-awaited heritage trip to the Basque Country in Spain and France. Realized 5 weeks before the trip that all four family members needed new or renewed passports. Fast Passport Center handled everything — two renewals and two first-time applications — all completed in 7 business days. Our family reunion in Bilbao was perfect.",
      service: "Family Passport Applications",
    },
    {
      name: "Tom L.",
      location: "Humboldt County — Rancher",
      rating: 5,
      text: "Cattle rancher traveling to the Calgary Stampede livestock exhibition with 2 weeks' notice. Passport was expired and I'd never been on an international flight before. Fast Passport Center walked me through the entire process — renewal in 5 business days. The team was patient with a first-time international traveler and I made the Stampede with time to spare.",
      service: "First-Time International Travel",
    },
    {
      name: "Karen S.",
      location: "Battle Mountain — School Teacher",
      rating: 5,
      text: "School teacher from Battle Mountain whose passport was lost during the move from Elko. Had a summer educational conference in Vancouver, BC in 18 days. Fast Passport Center helped with the DS-64 and got the replacement processed through their San Francisco courier in 4 business days. Professional and reassuring throughout.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "wm-1",
      name: "Winnemucca Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "850 Hanson St",
      city: "Winnemucca",
      state: "NV",
      zip: "89445",
      phone: "(775) 623-3663",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Winnemucca — Hanson Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary passport acceptance facility for Winnemucca and Humboldt County. Appointment required. The only passport acceptance location within a 70-mile radius in any direction.",
      icon: "ri-mail-line",
    },
    {
      id: "wm-2",
      name: "Battle Mountain Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "810 Sunset Dr",
      city: "Battle Mountain",
      state: "NV",
      zip: "89820",
      phone: "(775) 635-2421",
      hours: "Mon–Fri: 9:00 AM – 3:30 PM",
      distance: "Battle Mountain — 55 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative facility for Lander County residents and eastern Humboldt County. About 45 minutes from Winnemucca via I-80 east. Limited afternoon hours — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "wm-3",
      name: "Lovelock Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "390 Main St",
      city: "Lovelock",
      state: "NV",
      zip: "89419",
      phone: "(775) 273-2211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lovelock — 73 miles southwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Pershing County and southwestern Humboldt County residents. About 1 hour 15 minutes from Winnemucca via I-80 west. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "wm-4",
      name: "Elko Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "495 3rd St",
      city: "Elko",
      state: "NV",
      zip: "89801",
      phone: "(775) 738-3433",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Elko — 123 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest USPS facility in northeastern Nevada serving Elko County. About 2 hours from Winnemucca via I-80 east. Extended afternoon hours. The most reliable alternative facility for eastern Humboldt County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "wm-5",
      name: "Humboldt County Clerk's Office",
      type: "County Government Passport Acceptance",
      address: "50 W 5th St, Suite 207",
      city: "Winnemucca",
      state: "NV",
      zip: "89445",
      phone: "(775) 623-6343",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Winnemucca — 5th Street Courthouse",
      website: "https://www.hcnv.us/",
      websiteLabel: "Humboldt County Clerk",
      notes: "County government passport acceptance at the Humboldt County Courthouse in downtown Winnemucca. Often has more flexible scheduling than the post office. Call ahead to confirm current passport service hours.",
      icon: "ri-building-line",
    },
    {
      id: "wm-6",
      name: "Reno Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2000 Vassar St",
      city: "Reno",
      state: "NV",
      zip: "89510",
      phone: "(775) 786-6447",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM, Sat: 9:00 AM – 12:00 PM",
      distance: "Reno — 165 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest USPS passport facility in northern Nevada with Saturday hours. About 2.5 hours from Winnemucca via I-80 west. Best option for weekend service — the only Saturday passport acceptance within a 300-mile radius of Winnemucca.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to San Francisco Agency", agency: "390 miles — 6 hour drive via I-80, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-truck-line",
      title: "Assuming San Francisco Is Just a Day Trip From Winnemucca",
      description: "At 390 miles one way, driving from Winnemucca to the San Francisco Passport Agency at 450 Golden Gate Ave is a 6-hour trip each way — a 12-hour round trip. And the agency requires pre-scheduled NPIC appointments with no walk-ins accepted. During winter months, I-80 through Donner Pass can close completely, adding another layer of unpredictability.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Assuming Reno Has a Regional Passport Agency",
      description: "Many Winnemucca and northern Nevada residents assume Reno, as the closest major city, must have a passport agency. It does not. The closest regional passport agency is in San Francisco, 390 miles away. Reno only has passport acceptance facilities — post offices that accept DS-11 applications but cannot process or expedite them. The fastest option for rural northern Nevadans is courier service.",
    },
    {
      icon: "ri-image-line",
      title: "Getting Passport Photos From Locations Not Trained in Official Standards",
      description: "Winnemucca has limited photo service options — residents sometimes use photos from retail locations where staff may not be specifically trained on State Department passport photo specifications. Photos must be exactly 2x2 inches with a pure white background, neutral facial expression, and no glasses. A rejected photo causes the entire application to be returned and processing to restart from scratch — particularly problematic in rural areas with mail delays.",
    },
    {
      icon: "ri-file-list-line",
      title: "Renewing by Mail When an In-Person DS-11 Is Required",
      description: "Winnemucca residents with passports that expired more than 5 years ago, were issued before age 16, or reflect a name change without proper legal documentation must apply in person using Form DS-11 at an acceptance facility — not the mail-in DS-82. Filing the wrong form means automatic rejection and restarting the process, which in rural Nevada means losing several days to mail transit alone.",
    },
    {
      icon: "ri-snowy-line",
      title: "Not Accounting for Winter Weather in Mail Transit Times",
      description: "Winnemucca's high desert location at 4,300 feet elevation means winter snow can slow both mail transit and travel to acceptance facilities. USPS Priority Mail from Winnemucca can take 3–5 days to reach processing centers, compared to 1–2 days from urban areas. Overnight courier service bypasses this entirely — critical when you're counting days before international travel.",
    },
    {
      icon: "ri-global-line",
      title: "Mining Professionals Not Checking Passport Validity Before International Conferences",
      description: "Humboldt County's gold mining industry sends professionals to international conferences and site visits in Australia, Canada, Peru, and South Africa — often on short notice. Many don't check passport validity until the travel order arrives, only to discover their passport has expired or has insufficient validity remaining. Most countries require 6 months of passport validity beyond your return date.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS or FedEx location in Winnemucca or arrange pickup." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the San Francisco Passport Agency — 390 miles via I-80." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the San Francisco Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Winnemucca or Humboldt County address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Winnemucca from the San Francisco passport agency?",
      a: "Winnemucca is approximately 390 miles from the San Francisco Passport Agency at 450 Golden Gate Ave — about a 6 hour drive via I-80 west through Reno, over Donner Pass, through Sacramento, and into San Francisco. Winnemucca's location right on I-80 provides a direct route, but the San Francisco agency requires pre-scheduled NPIC appointments and absolutely no walk-ins. A round trip from Winnemucca to San Francisco is a 12-hour commitment, and winter conditions through the Sierra Nevada can make travel impossible.",
    },
    {
      q: "Does Winnemucca, NV have its own passport agency?",
      a: "No. Winnemucca does not have a passport agency and neither does Reno or anywhere in Nevada. The closest regional passport agency is the San Francisco Passport Agency at 450 Golden Gate Ave, about 390 miles away. Winnemucca has two acceptance facilities — the Winnemucca Post Office on Hanson Street and the Humboldt County Clerk's Office in the courthouse — but acceptance facilities can only accept DS-11 applications, not process or expedite them.",
    },
    {
      q: "Where do Winnemucca travelers typically fly internationally?",
      a: "Winnemucca residents typically use Reno-Tahoe International Airport (RNO), about 165 miles west via I-80 — roughly a 2.5 hour drive. RNO offers domestic connections to major hubs including San Francisco, Denver, Phoenix, Las Vegas, and Seattle for international connections. Some northern Nevadans also use Salt Lake City International (SLC, about 5 hours east) or drive the full distance to San Francisco International (SFO) for more direct international flight options.",
    },
    {
      q: "How fast can I get an emergency passport in Winnemucca?",
      a: "Emergency processing is typically 24–48 hours for Winnemucca residents. While Winnemucca is remote by Nevada standards, overnight courier routing via I-80 to San Francisco is highly reliable. Standard expedited processing runs 2–9 business days. Our courier service eliminates the 12-hour round trip drive to San Francisco and bypasses the slower USPS mail transit from rural ZIP code 89445.",
    },
    {
      q: "Where can I get passport photos in Winnemucca?",
      a: "Walmart Supercenter at 3010 Potato Rd in Winnemucca offers passport photo services. There's also a Walgreens at 1050 W Haskell St. Photo options are limited in Humboldt County — the nearest alternative locations are in Elko (123 miles east) or Reno (165 miles west). Always verify your photos meet exact 2x2 inch specifications with a white background before submitting, as retakes require another trip.",
    },
    {
      q: "Does the Winnemucca Post Office take walk-in passport appointments?",
      a: "The Winnemucca Post Office at 850 Hanson St accepts passport applications by appointment Monday through Friday from 9:00 AM to 4:00 PM. Walk-ins are generally not accepted — call (775) 623-3663 to schedule. Given that this is the only post office passport facility within a 70-mile radius, appointments can fill quickly, especially during the summer travel season.",
    },
    {
      q: "Can the Humboldt County Clerk process my passport application?",
      a: "Yes. The Humboldt County Clerk's Office at 50 W 5th St, Suite 207 in the Humboldt County Courthouse offers passport acceptance services Monday through Friday from 8:00 AM to 5:00 PM. This can be a good alternative to the post office with potentially more flexible scheduling. Call (775) 623-6343 to confirm current hours and availability.",
    },
    {
      q: "I work in the mining industry — how fast can I get a passport for international travel?",
      a: "Humboldt County mining professionals heading to international conferences in Australia, Canada, Peru, or South Africa on short notice can get emergency passport processing in 24–48 hours. Fast Passport Center has experience handling mining industry professional travel and understands the urgency when a conference registration or site visit requires immediate international travel.",
    },
    {
      q: "Can Fast Passport Center help Battle Mountain and Lovelock residents too?",
      a: "Absolutely. We serve all of Humboldt, Lander, and Pershing counties including Winnemucca, Battle Mountain, Lovelock, McDermitt, Golconda, Valmy, and Paradise Valley. Residents of these rural communities never need to drive to Winnemucca or San Francisco — everything is handled via secure overnight courier directly from their location.",
    },
    {
      q: "Is there an acceptance facility near Winnemucca open on Saturday?",
      a: "The closest Saturday passport acceptance facility to Winnemucca is the Reno Main Post Office at 2000 Vassar St, about 165 miles west — a 2.5 hour drive each way. Saturday hours are 9:00 AM to 12:00 PM. The Winnemucca, Battle Mountain, and Lovelock post offices do not offer Saturday hours. The Humboldt County Clerk's Office is also closed on weekends.",
    },
    {
      q: "How does winter weather affect passport processing for Winnemucca?",
      a: "Winnemucca's high desert elevation of 4,300 feet means winter snow is common from November through March. Standard USPS mail transit from rural northern Nevada takes 3–5 days each way during winter months. I-80 through Donner Pass between Reno and Sacramento can close during severe storms. Courier service bypasses both USPS winter delays and I-80 closure risks — critical when your international travel date is approaching.",
    },
    {
      q: "I'm traveling for the Basque festival season — when should I start my passport?",
      a: "Winnemucca has deep Basque heritage, and many local families travel to the Basque Country in Spain and France for festivals and family reunions, particularly in summer. Start passport applications at least 4–6 months before your planned travel. Summer is not only the busiest festival season in the Basque Country — it's also the State Department's busiest passport processing period nationwide.",
    },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Winnemucca", address: "3010 Potato Rd, Winnemucca, NV 89445", hours: "Mon–Sun: 7AM–9PM" },
    { name: "Walgreens — Winnemucca", address: "1050 W Haskell St, Winnemucca, NV 89445", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Walmart — Elko", address: "2944 Mountain City Hwy, Elko, NV 89801", hours: "Mon–Sun: 7AM–9PM" },
    { name: "Walgreens — Elko", address: "2515 Mountain City Hwy, Elko, NV 89801", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Walgreens — Fernley", address: "1350 Hwy 95A S, Fernley, NV 89408", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Costco Photo — Reno", address: "2200 Harvard Way, Reno, NV 89502", hours: "Mon–Fri: 10AM–8PM, Sat: 9:30AM–6PM, Sun: 10AM–6PM" },
  ],
  dmvLocations: [
    { name: "Nevada DMV — Winnemucca (Field Office)", address: "3505 Construction Way, Winnemucca, NV 89445", hours: "Wed–Thu: 8:00AM–4:30PM", note: "Rural field office open only Wednesdays and Thursdays. REAL ID, driver's license, and state ID services. Call ahead to confirm hours as they may change seasonally. The most remote DMV office in northern Nevada.", featured: true },
    { name: "Nevada DMV — Elko", address: "3920 E Idaho St, Elko, NV 89801", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Full-service DMV office serving northeastern Nevada. About 2 hours from Winnemucca via I-80 east. REAL ID and all standard DMV services available.", featured: false },
    { name: "Nevada DMV — Reno (Galletti Way)", address: "305 Galletti Way, Reno, NV 89512", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Major DMV office serving the Reno-Sparks metro area. About 2.5 hours from Winnemucca. Full service including REAL ID. Appointment strongly recommended.", featured: false },
  ],
  airports: [
    {
      code: "RNO",
      name: "Reno-Tahoe International Airport",
      distance: "165 miles west of Winnemucca",
      address: "2001 E Plumb Ln, Reno, NV 89502",
      note: "The primary commercial airport serving northern Nevada. About 2.5 hours from Winnemucca via I-80 west. Domestic connections to major hubs including San Francisco, Denver, Phoenix, Las Vegas, Salt Lake City, and Seattle. The closest airport with regular commercial service to Winnemucca.",
      flightUrl: "https://www.renoairport.com/",
      flightLabel: "RNO Airport",
      featured: true,
    },
    {
      code: "SLC",
      name: "Salt Lake City International Airport",
      distance: "360 miles east of Winnemucca",
      address: "776 N Terminal Dr, Salt Lake City, UT 84122",
      note: "Major Delta Air Lines hub with extensive domestic and international route network including direct flights to Europe. About 5 hours via I-80 east. The closest major international gateway for Winnemucca residents heading overseas.",
      flightUrl: "https://www.slcairport.com/",
      flightLabel: "SLC Airport",
      featured: false,
    },
    {
      code: "SFO",
      name: "San Francisco International Airport",
      distance: "400 miles southwest of Winnemucca",
      address: "San Francisco, CA 94128",
      note: "Major international gateway with direct flights to Asia, Europe, and the Americas. About 6–7 hours via I-80 west. Extensive international route network as a United Airlines hub.",
      flightUrl: "https://www.flysfo.com/",
      flightLabel: "SFO Airport",
      featured: false,
    },
    {
      code: "SMF",
      name: "Sacramento International Airport",
      distance: "300 miles southwest of Winnemucca",
      address: "6900 Airport Blvd, Sacramento, CA 95837",
      note: "Mid-size airport with domestic and limited international routes. About 5 hours via I-80 west. Southwest Airlines focus city. Alternative to Reno for domestic connections with more route options.",
      flightUrl: "https://sacramento.aero/smf",
      flightLabel: "SMF Airport",
      featured: false,
    },
  ],
};